import { RiCloseFill } from "react-icons/ri";

/**
 * Drawer component that slides in from the right.
 * Props:
 * - open: boolean (controls visibility)
 * - onClose: function (called when overlay or close button is clicked)
 * - width: number (optional, default 400)
 * - children: content to render inside the drawer
 * - title: string (optional)
 */
export default function Drawer({ open, onClose, width = 400, children, title }) {
    return (
        <>
            {/* Overlay to catch outside clicks, only visible when open */}
            <div
                style={{
                    display: open ? 'block' : 'none',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.01)',
                    zIndex: 1999,
                }}
                onClick={onClose}
            />
            {/* Drawer is always rendered for animation */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    width: width,
                    height: '100%',
                    background: '#fff',
                    boxShadow: '-2px 0 8px rgba(0,0,0,0.15)',
                    zIndex: 2000,
                    padding: 0,
                    overflowY: 'auto',
                    transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.2s',
                    transform: open ? 'translateX(0)' : 'translateX(100%)',
                    opacity: open ? 1 : 0,
                    pointerEvents: open ? 'auto' : 'none',
                    willChange: 'transform, opacity',
                }}
                className="bg-light w-50 shadow rounded text-start  position-fixed  slide-in"
                onClick={e => e.stopPropagation()}
            >
                <button className="btn rounded-0 shadow" style={{ float: 'right' }} onClick={onClose}><RiCloseFill /></button>
                {title && <h3>{title}</h3>}
                {children}
            </div>
        </>
    );
}
